<template>
  <div>
    <div
      class="weather"
      v-if="isShowCard"
      :style="'background-image:url(' + weatherBg + ')'"
    >
      <!-- 左侧：当前温度 -->
      <div class="left">{{ weather.temperature }}</div>
      <!-- 中间：地区、 最高温度/最低温度-->
      <div class="center">
        <div class="img"></div>
        <p>{{ weather.local_city }}</p>
        <p>
          {{ weather.weather_condition }}
          <span>{{ weather.temp_high }}℃/{{ weather.temp_low }}℃</span>
        </p>
      </div>
      <!-- 右侧：天气预警、空气质量-->
      <div class="right">
        <div v-if="isShowWarning" class="weather-warn">
          <!-- <div class="circle" :style="valueHandle(1, weather.warning_level)"></div> -->
          <!-- {{valueHandle(2, weather.warning_level)}} -->
          <span>{{ warningHandle(weather.warning_code) }}预警</span>
        </div>
        <div
          v-if="weather.aqi_value"
          :class="{ 'weather-quality': true, margin: isShowWarning }"
        >
          <div class="circle" :style="valueHandle(3, weather.aqi_value)"></div>
          <span
            >{{ valueHandle(4, weather.aqi_value) }}
            {{ weather.aqi_value }}</span
          >
        </div>
      </div>
      <div class="des">本地天气</div>
    </div>
  </div>
</template>
<script>
/* eslint-disable max-len, global-require */

/**
  weather: {
    timestamp: 1557136799, // 服务器时间
    temperature: 20, // 当前温度（摄氏度）
    temp_high: 30, // 最高温度（摄氏度）
    temp_low: 10, // 最低温度（摄氏度）
    local_city: '朝阳区朝阳区朝阳区朝阳区朝阳区朝阳区朝阳区', // 县级市信息
    weather_num: '1', // 天气状况编号
    weather_condition: '晴晴晴晴晴晴晴晴晴晴晴', // 实时天气状况
    aqi_value: 30, // 空气质量数值
    warning_code: '400', // 预警编号
    warning_level: '黄色', // 天气预警等级
  },
*/
export default {
  props: ['weather'],
  data() {
    return {
      weatherBg: null,
      isShowCard: false,
      isShowWarning: true, // 是否显示天气预警信息
    };
  },
  mounted() {
    console.log(this.weather);
    this.weatherBg = this.weatherBgHandle(Number(this.weather.weather_num));
    this.isShowCard = true;
  },
  methods: {
    // 天气卡片背景匹配
    weatherBgHandle(weatherNum) {
      const date = new Date();
      const timeFlag = date.getHours() >= 6 && date.getHours() < 18 ? 1 : 0; // 1白天，0夜晚
      const bgObj = {
        list: [
          {
            des: '晴',
            arr: [0, 30],
            day: require('../../../../assets/weather/1_sunny_bike_day.jpg'),
            night: require('../../../../assets/weather/1_sunny_bike_night.jpg'),
          }, {
            des: '多云、阴',
            arr: [1, 2, 31],
            day: require('../../../../assets/weather/2_cloudy_navigate_day.jpg'),
            night: require('../../../../assets/weather/2_cloudy_navigate_night.jpg'),
          }, {
            des: '雨',
            arr: [3, 4, 5, 7, 8, 9, 10, 19, 33],
            day: require('../../../../assets/weather/3_rainy_taxi_day.jpg'),
            night: require('../../../../assets/weather/3_rainy_taxi_night.jpg'),
          }, {
            des: '雪',
            arr: [6, 13, 14, 15, 16, 17, 34],
            day: require('../../../../assets/weather/4_snowy_day.jpg'),
            night: require('../../../../assets/weather/4_snowy_night.jpg'),
          }, {
            des: '雾、霾、扬沙',
            arr: [18, 20, 29, 32, 35, 36, 45, 46],
            day: require('../../../../assets/weather/5_smoggy_day.jpg'),
            night: require('../../../../assets/weather/5_smoggy_night.jpg'),
          }
        ],
        backup: {
          des: '兜底类型, 单独处理',
          day: require('../../../../assets/weather/6_backup_day.jpg'),
          night: require('../../../../assets/weather/6_backup_night.jpg'),
        }
      };

      let bg = null;
      bgObj.list.forEach((ele) => {
        if (ele.arr.indexOf(weatherNum) !== -1) {
          bg = timeFlag === 1 ? ele.day : ele.night;
        }
      });
      if (!bg) {
        bg = timeFlag === 1 ? bgObj.backup.day : bgObj.backup.night;
      }
      return bg;
    },
    // 颜色匹配
    valueHandle(type, value) {
      let newValue = null;
      const warnArr = [
        // 天气预警
        { level: 1, des: '蓝色', color: '#1b5bfd' },
        { level: 2, des: '黄色', color: '#fff36c' },
        { level: 3, des: '橙色', color: '#ff7f00' },
        { level: 4, des: '红色', color: '#ff0000' },
      ];
      const qualityArr = [
        // 空气质量
        { level: [0, 50], des: '优', color: '#78fe81' },
        { level: [51, 100], des: '良', color: '#fff36c' },
        { level: [101, 150], des: '轻度污染', color: '#ff7f00' },
        { level: [151, 200], des: '中度污染', color: '#ff0000' },
        { level: [201, 300], des: '重度污染', color: '#9f0150' },
        { level: [301], des: '严重污染', color: '#6f011f' },
      ];
      if (type === 1) { // 匹配预警等级颜色
        warnArr.forEach((item) => {
          if (item.level === value) {
            newValue = `background:${item.color}`;
          }
        });
      } else if (type === 2) { // 匹配预警等级值
        warnArr.forEach((item) => {
          if (item.level === value) {
            newValue = item.des;
          }
        });
      } else if (type === 3) { // 匹配空气质量颜色
        qualityArr.forEach((item) => {
          if (item.level[1] && (value >= item.level[0] && value <= item.level[1])) {
            newValue = `background:${item.color}`;
          } else if (!item.level[1] && value >= item.level[0]) {
            newValue = `background:${item.color}`;
          }
        });
      } else if (type === 4) { // 匹配空气质量值
        qualityArr.forEach((item) => {
          if (item.level[1] && (value >= item.level[0] && value <= item.level[1])) {
            newValue = item.des;
          } else if (!item.level[1] && value >= item.level[0]) {
            newValue = item.des;
          }
        });
      }
      console.log(newValue);
      return newValue;
    },
    // 预警事件匹配
    warningHandle(numCode) {
      const codeArr = [
        { code: 402, event: '台风' },
        { code: 406, event: '暴雨' },
        { code: 409, event: '暴雪' },
        { code: 412, event: '寒潮' },
        { code: 401, event: '大风' },
        { code: 413, event: '沙尘暴' },
        { code: 414, event: '高温' },
        { code: 415, event: '干旱' },
        { code: 416, event: '雷电' },
        { code: 410, event: '冰雹' },
        { code: 417, event: '霜冻' },
        { code: 404, event: '大雾' },
        { code: 418, event: '霾' },
        { code: 503, event: '道路结冰' },
      ];
      let event = null;
      codeArr.forEach((ele) => {
        if (Number(ele.code) === Number(numCode)) {
          ({ event } = ele);
        }
      });
      if (!event) {
        this.isShowWarning = false;
      }
      return event;
    }
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../../../common/css/common-mixin";
@import "../../css/flex-mixin.scss";

@font-face {
  font-family: "oswald";
  src: url("../../font/Oswald-Regular-all.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

.weather {
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  width: rpx(670);
  height: 100%;
  padding: rpx(24);
  border-radius: rpx(16);
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
  overflow: hidden;
  @include mix-flex;
  @include mix-flex-direction;
  @include mix-flex-wrap;
  .left {
    color: rgba(255, 255, 255, 0.87);
    font-size: rpx(112);
    font-family: "oswald";
    line-height: rpx(112);
  }
  .center {
    @include mix-flex-grow(1);
    margin: 0 rpx(12) 0 rpx(10);
    .img {
      width: rpx(46);
      height: rpx(46);
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAApCAMAAABwfJv6AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAB4UExURUdwTP///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////4MhPqcAAAAndFJOUwDBGeWE7Jb3yW4DZYBO2/yJpTwNvCddZy0UHnZUs4Le76vdnTRCY5im6JsAAAE2SURBVHja3ZTZeoMgEIVRsRD3PSbWLE1a3v8Nyykg5ht9gOa/cZg5HFAG2X8h5DIuY8lD5ul5EAkRyarxuaNQBnF0qdNdLQRnp1MeqwyvakXUmyT8imzIvuBpVg8UuMmuUEAmSHK4tzpoUeZI5ajGnwi/Y8R/odSB8R4xGUGNYo7ITuoQ6SkRM0TaRz+SGzZjcwksBdYujY01L/WjgUnNLB1Gz03HAaUMCb8Pu8fxZY8TSpMTPjD60cHl5a0v9juogxM2qabf/I4fRkhIlSdlu0Iol7OGjgh3u4cKKW8vzLnmSVXkCB/uilAOril89wxU5dqscqPZtRmlWbofFBiNROS7v7XHq8xV2KRerV0hnqnG37wyS7T5VJrrukOngJCBUCBge5wKteJ6poqtn9S8o6O/vffjF2PpOB/kVW0LAAAAAElFTkSuQmCC");
      background-size: rpx(40) rpx(40);
      background-repeat: no-repeat;
      background-position: center left;
    }
    p {
      color: rgba(255, 255, 255, 0.7);
      font-size: rpx(24);
      font-family: PingFang-SC-Medium;
      line-height: rpx(36);
    }
  }
  .right {
    text-align: right;
    .weather-warn,
    .weather-quality {
      display: inline-block;
      white-space: nowrap;
      color: #ffffff;
      font-size: rpx(22);
      font-family: PingFang-SC-Medium;
      line-height: rpx(24);
      vertical-align: middle;
      padding: rpx(12) rpx(16);
      background: rgba(0, 0, 0, 0.12);
      border-radius: rpx(48);
      padding-left: rpx(34);
      .circle {
        display: inline-block;
        position: absolute;
        margin: auto;
        top: 0;
        bottom: 0;
        left: rpx(13);
        width: rpx(14);
        height: rpx(14);
        border-radius: 50%;
      }
    }
    .weather-warn {
      position: absolute;
      top: 0;
      right: 0;
      padding-left: rpx(12);
    }
    .weather-quality {
      position: absolute;
      top: 0;
      right: 0;
      margin-top: rpx(0);
    }
    .weather-quality.margin {
      position: relative;
      margin-top: rpx(64);
    }
  }
  .des {
    position: absolute;
    bottom: 0;
    right: 0;
    width: rpx(120);
    color: #fff;
    font-size: rpx(22);
    font-family: PingFang-SC-Medium;
    line-height: rpx(33);
    padding: rpx(7) 0;
    text-align: center;
    border-top-left-radius: rpx(16);
    border-bottom-right-radius: rpx(16);
    background: rgba(0, 0, 0, 0.12);
  }
}
</style>
